<div class="policy-explorer-shell" *ngIf="!loading && !error && vm as x; else busyOrError">
  <div class="shell-top">
    <div class="toolbar-row">
      <button *ngFor="let btn of visibleButtons"
              type="button"
              class="toolbar-btn"
              [ngClass]="btn.intent || 'secondary'"
              [disabled]="!btn.enabled"
              (click)="onToolbar(btn)">
        <span class="toolbar-btn-label">{{ btn.label }}</span>
      </button>

      <div class="toolbar-dropdown" (click)="$event.stopPropagation()">
        <button type="button"
                class="toolbar-btn secondary"
                (click)="toggleExportMenu($event)">
          <span class="toolbar-btn-label">Export</span>
          <span class="toolbar-btn-caret">▼</span>
        </button>

        <div class="toolbar-dropdown-menu" *ngIf="exportMenuOpen">
          <button type="button"
                  class="toolbar-dropdown-item"
                  (click)="exportAs('csv', $event)">
            CSV
          </button>

          <button type="button"
                  class="toolbar-dropdown-item"
                  (click)="exportAs('json', $event)">
            JSON
          </button>

          <button type="button"
                  class="toolbar-dropdown-item"
                  (click)="exportAs('xml', $event)">
            XML
          </button>
        </div>
      </div>
      <button type="button"
              class="toolbar-btn secondary"
              (click)="toggleAttachments()"
              [class.active]="activeTab === 'attachments'"
              *ngIf="loginService.userOptional">
        <span class="toolbar-btn-label">Attachments</span>
      </button>
    </div>
    <div *ngIf="activeTab === 'attachments' && clientId && recordId" class="attachments-container">
      <app-attachment [clientId]="clientId"
                      [recordId]="recordId"
                      [dataSetId]="dataSetId">
      </app-attachment>
    </div>
    <div class="breadcrumb-row">
      <ng-container *ngFor="let crumb of x.breadcrumbs; let last = last">
        <a href="javascript:void(0)"
           (click)="navigateBreadcrumb(crumb.nodeKey)"
           [class.last]="last">
          {{ crumb.label }}
        </a>
        <span *ngIf="!last" class="sep">/</span>
      </ng-container>
    </div>
  </div>
  <div class="main-layout">
    <aside class="tree-pane">
      <div class="pane-title">Navigation</div>

      <ng-template #recursiveTree let-nodes>
        <ul class="tree-root">
          <li *ngFor="let node of nodes; trackBy: trackByNode">
            <div class="tree-node"
                 [class.selected]="node.selected"
                 [class.child]="node.nodeType === 2 || node.nodeType === 'ChildList'"
                 (click)="selectNode(node, $event)">
              <span class="tree-node-bullet"></span>
              <span class="tree-node-label">{{ node.label }}</span>
            </div>

            <ng-container *ngIf="node.children?.length"
                          [ngTemplateOutlet]="recursiveTree"
                          [ngTemplateOutletContext]="{ $implicit: node.children }">
            </ng-container>
          </li>
        </ul>
      </ng-template>

      <ng-container [ngTemplateOutlet]="recursiveTree"
                    [ngTemplateOutletContext]="{ $implicit: x.tree }">
      </ng-container>
    </aside>

    <section class="content-pane">
      <div *ngIf="isRecordKind(x.content.kind)" class="record-card">
        <div class="content-header">
          <div>
            <div class="content-kicker">Record</div>
            <h2>{{ x.content.record?.title }}</h2>
          </div>

          <div class="content-badges">
            <span class="badge" [class.badge-on]="x.content.record?.canEditRecord">
              {{ x.content.record?.canEditRecord ? 'Editable' : 'Read only' }}
            </span>

            <span class="badge" [class.badge-on]="editMode">
              {{ editMode ? 'Edit mode' : 'View mode' }}
            </span>

            <span class="badge" *ngIf="editMode && hasAnyDirty()">
              {{ dirtyCount() }} unsaved field change{{ dirtyCount() === 1 ? '' : 's' }}
            </span>

            <span class="badge" *ngIf="hasAnyUnsavedChanges()">
              {{ dirtyRecordCount() }} draft record{{ dirtyRecordCount() === 1 ? '' : 's' }}
            </span>
          </div>
        </div>

        <div class="field-grid">
          <div class="field-row"
               *ngFor="let field of x.content.record?.fields; trackBy: trackByField"
               [class.field-row-dirty]="isDirty(field.fieldName)"
               [class.field-row-calculated]="field.isCalculated">
            <div class="field-label">{{ field.displayName }}</div>

            <div class="field-value">
              <ng-container *ngIf="!(editMode && field.canEdit); else editorMode">
                {{ field.formattedValue || field.value || '—' }}
              </ng-container>

              <ng-template #editorMode>
                <input *ngIf="editorKind(field) === 'text'"
                       type="text"
                       class="editor-input"
                       [value]="editedValues[field.fieldName]"
                       (input)="onFieldChange(field, $any($event.target).value)" />

                <textarea *ngIf="editorKind(field) === 'textarea'"
                          class="editor-textarea"
                          [value]="editedValues[field.fieldName]"
                          (input)="onFieldChange(field, $any($event.target).value)">
                </textarea>

                <input *ngIf="editorKind(field) === 'number'"
                       type="number"
                       class="editor-input"
                       [value]="editedValues[field.fieldName]"
                       (input)="onFieldChange(field, $any($event.target).valueAsNumber)" />

                <input *ngIf="editorKind(field) === 'date'"
                       type="date"
                       class="editor-input"
                       [value]="editedValues[field.fieldName]"
                       (input)="onFieldChange(field, $any($event.target).value)" />

                <input *ngIf="editorKind(field) === 'datetime'"
                       type="datetime-local"
                       class="editor-input"
                       [value]="editedValues[field.fieldName]"
                       (input)="onFieldChange(field, $any($event.target).value)" />

                <label *ngIf="editorKind(field) === 'checkbox'" class="editor-checkbox">
                  <input type="checkbox"
                         [checked]="!!editedValues[field.fieldName]"
                         (change)="onFieldChange(field, $any($event.target).checked)" />
                  <span>Enabled</span>
                </label>
              </ng-template>
            </div>

            <div class="field-edit">
              <span *ngIf="field.canEdit; else roLabel">
                {{ editMode ? 'Editing' : 'Editable' }}
              </span>
              <ng-template #roLabel>Read only</ng-template>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isGridKind(x.content.kind) && x.content.grid as grid" class="grid-card">
        <div class="content-header">
          <div>
            <div class="content-kicker">Child records</div>
            <h2>{{ grid.title }}</h2>
          </div>

          <div class="content-badges">
            <span class="badge" *ngIf="grid.canAdd">Add</span>
            <span class="badge" *ngIf="grid.canDelete">Delete</span>
          </div>
        </div>

        <div class="grid-toolbar">
          <div class="grid-toolbar-left">
            <input #searchBox
                   type="text"
                   class="grid-search"
                   [value]="search"
                   placeholder="Search rows..."
                   (keyup.enter)="runSearch(searchBox.value)" />

            <button type="button" class="ghost-btn" (click)="runSearch(searchBox.value)">Search</button>
            <button type="button" class="ghost-btn" (click)="clearSearch()">Clear</button>
          </div>

          <div class="grid-toolbar-right">
            <label class="page-size-label">
              Page size
              <select [value]="pageSize" (change)="onPageSizeChange($any($event.target).value)">
                <option [value]="10">10</option>
                <option [value]="25">25</option>
                <option [value]="50">50</option>
                <option [value]="100">100</option>
              </select>
            </label>
          </div>
        </div>

        <div class="grid-scroll-wrap">
          <table class="content-grid">
            <thead>
              <tr>
                <th class="sticky-col sortable" (click)="sortBy({ fieldName: '_descriptor', displayName: 'Record', sortable: true })">
                  Record
                </th>
                <th *ngFor="let col of grid.columns; trackBy: trackByColumn"
                    [class.sortable]="col.sortable"
                    [class.field-row-calculated]="col.isCalculated"
                    (click)="sortBy(col)">
                  {{ col.displayName }}
                  <span class="sort-indicator" *ngIf="sortField === col.fieldName">
                    {{ sortDirection === 'asc' ? '▲' : '▼' }}
                  </span>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of grid.rows; trackBy: trackByRow"
                  (click)="openGridRow(row)">
                <td class="descriptor-cell sticky-col">{{ row.descriptor }}</td>
                <td *ngFor="let col of grid.columns; trackBy: trackByColumn"
                  [class.calc-cell]="col.isCalculated">
                  {{ row.formattedValues[col.fieldName] ?? '—' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="grid-footer">
          <div class="grid-summary">
            Showing
            {{ ((grid.page - 1) * grid.pageSize) + (grid.rows.length ? 1 : 0) }}
            -
            {{ ((grid.page - 1) * grid.pageSize) + grid.rows.length }}
            of {{ grid.totalRows }}
          </div>

          <div class="pager">
            <button type="button" class="ghost-btn" (click)="goToPage(grid.page - 1)" [disabled]="grid.page <= 1">
              Prev
            </button>
            <span class="pager-page">Page {{ grid.page }} / {{ totalPages(grid) }}</span>
            <button type="button" class="ghost-btn" (click)="goToPage(grid.page + 1)" [disabled]="grid.page >= totalPages(grid)">
              Next
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!isRecordKind(x.content.kind) && !isGridKind(x.content.kind)" class="empty-state">
        Unknown content kind: {{ x.content.kind | json }}
      </div>
    </section>
  </div>
</div>

<ng-template #busyOrError>
  <div class="busy" *ngIf="loading">Loading...</div>
  <div class="error" *ngIf="!loading && error">{{ error }}</div>
</ng-template>
